<template>
  <div class="misc-wrapper">
    <b-link class="brand-logo">
      <logo />
      <h2 class="brand-text text-primary ml-1">
          Salescore
      </h2>
    </b-link>

    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <div>
            <b-spinner
            style="width: 3rem; height: 3rem;"
            label="Large Spinner"
            type="grow"
        />
        <h2 class="mb-1">
          No tiene acceso para la aplicación 🔐
        </h2>
        </div>
        <b-img
          fluid
          :src="imgUrl"
          alt="Not authorized page"
        />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */

import Logo from '@core/layouts/components/Logo.vue'
import store from '@/store/index'
import { mapState } from 'vuex'

export default {
  components: {
    Logo,
  },
  data() {
    return {
      downImg: require('@/assets/images/pages/not-authorized.svg'),
    }
  },
  created(){
    if( this.isLogged ){
      this.$router.push({name: 'sales'})
    }
  },
  computed: {
    ...mapState('uiAppConfig',['tokenApp']),    
    ...mapState('auth',['user','isLogged']),          
    imgUrl() {      
      if (store.state.uiAppConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.downImg = require('@/assets/images/pages/not-authorized-dark.svg')
        return this.downImg
      }
      return this.downImg
    },
  },  
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-misc.scss';
</style>
